import Header from "../../../common/Header"
import CourseDetails from "../../../common/CourseDetails"
import ReachAdvisorBanner from "../../../common/ReachAdvisorBanner"
import Footer from "../../../common/Footer"
import courseData from "./Algebra2B.json"

export default function Algebra2B() {
    
    return (
        <>
            <Header/>
            <CourseDetails courseData = {courseData}/>
            <ReachAdvisorBanner/>
            <Footer/>
        </>
    )
}